const { default: axiosIns } = require('@/libs/axios')

const LanguageService = {
  // GET - LanguageApiController
  async getLanguageResources() {
    return axiosIns.get('/language/languagesresources').then(response => response.data)
  },
  async getLanguages() {
    return axiosIns.get('/language/languages').then(response => response.data)
  },
  // PATCH - LanguageApiController
  async changeUserPreferences(languageId) {
    return axiosIns.patch(`/preferences/language/${languageId}`).then(response => response.data)
  },
  // POST - LanguageApiController
  async createResource(key) {
    return axiosIns.post(`/language/${key}`).then(response => response.data)
  },
}

export default LanguageService
